module.exports = __webpack_public_path__ + "static/media/ic_fan_close.b68960a0.png";